/**
 * Contrato de `POST /parsesearchquery`.
 * @see docs/maps/natural-language-search.md
 * @see argenlotapi/docs/frontend/FRONTEND_PARSE_SEARCH_QUERY.md
 */

export const NL_SEARCH_SCHEMA_VERSION = 'parcel-filters-v1';

/** POST `context` para parsear Lote ∪ Publicación (lista compartida). */
export const NL_SEARCH_SHARED_CONTEXT = 'shared-list';

/** Respuesta de parse con chips de lista (no es el schema del mapa país). */
export const NL_SEARCH_SHARED_SCHEMA_VERSION = 'shared-list-v1';

/** POST `context` para lista CAD (`/#/lista/:id`). */
export const NL_SEARCH_CAD_CONTEXT = 'cad-list';

/** Respuesta de parse con chips de ficha CAD. */
export const NL_SEARCH_CAD_SCHEMA_VERSION = 'cad-list-v1';

export const NL_SEARCH_MIN_CHARS = 4;

/** Tope del input: defensa ante pegar un wall of text al LLM. */
export const NL_SEARCH_MAX_CHARS = 400;

export const NL_SEARCH_TIMEOUT_MS = 8000;

export const NL_SEARCH_INTENTS = {
  place: 'place',
  filter: 'filter',
  hybrid: 'hybrid',
  unknown: 'unknown',
};

/** Placeholder con NL activo pero sin sesión: muestra la capacidad, no habilita el input. */
export const NL_SEARCH_LOGGED_OUT_PLACEHOLDER = 'Describí lotes o un lugar — iniciá sesión para buscar';

/**
 * Estado 0 — placeholder del input (sin foco). Frases que alguien usaría,
 * cada una con filtros v1. Pool distinto al de las chips.
 */
export const NL_SEARCH_PLACEHOLDER_EXAMPLES = [
  'Ej. Baldíos entre 200 y 500 m² en zonas urbanas',
  'Ej. Lotes en esquina con PH',
  'Ej. Baldíos urbanos sin cloaca en Córdoba',
  'Ej. Barrio cerrado en Córdoba',
  'Ej. Lotes rurales de más de 5000 m²',
];

/**
 * Estado 1 — chips "Sugeridas". Frases más concretas, pool distinto del placeholder.
 * No compartir texto con `NL_SEARCH_PLACEHOLDER_EXAMPLES`.
 */
export const NL_SEARCH_SUGGESTED_QUERIES = [
  'Lotes baldíos de 200 a 500 m² en Nueva Córdoba',
  'Terrenos en barrio cerrado de 500 a 1000 m² en Córdoba',
  'Lotes rurales de más de 5000 m² en Mendoza',
  'Lotes urbanos en esquina sin cloaca',
];

/**
 * Estado 0 en lista compartida: frases más concretas (operación + unidad + lugar).
 * Distinto del pool de chips Sugeridas.
 */
export const NL_SEARCH_SHARED_PLACEHOLDER_EXAMPLES = [
  'Ej. Departamento en venta en Nueva Córdoba, 2 habitaciones',
  'Ej. Casa en alquiler con baño y cochera',
  'Ej. Depto de 80 m² con 2 dormitorios',
  'Ej. PH en venta, 3 habitaciones',
  'Ej. Baldío en alquiler en Córdoba',
  'Ej. Deptos en venta de menos de 150 mil dólares',
];

export const NL_SEARCH_SHARED_SUGGESTED_QUERIES = [
  'En venta',
  'Depto de 80 m2',
  '2 dormitorios',
  'Baldíos en alquiler',
  'Barato',
];

export const NL_SEARCH_CAD_PLACEHOLDER_EXAMPLES = [
  'Ej. Lotes en venta de 200 a 500 m²',
  'Ej. Disponibles de menos de 80 mil dólares',
  'Ej. Lotes residenciales en oferta',
  'Ej. Más de 500 m²',
];

export const NL_SEARCH_CAD_SUGGESTED_QUERIES = [
  'En venta',
  'Lotes de 200 a 500 m2',
  'Disponibles',
  'En oferta',
  'Menos de 80 mil dólares',
];

/** Tope de ítems en el dropdown idle (recientes + relleno de sugeridas). */
export const NL_SEARCH_IDLE_MAX_ITEMS = 4;

/** Tope de búsquedas recientes en localStorage. */
export const NL_SEARCH_RECENT_MAX = 4;

/** Buckets de Recientes: mapa país vs lista compartida. */
export const NL_SEARCH_RECENT_SCOPE_MAP = 'map';
export const NL_SEARCH_RECENT_SCOPE_SHARED = NL_SEARCH_SHARED_CONTEXT;
export const NL_SEARCH_RECENT_SCOPE_CAD = NL_SEARCH_CAD_CONTEXT;

/**
 * Un ejemplo al azar. El placeholder se elige al montar y no rota.
 * @param {string[]} [examples]
 * @returns {string}
 */
export function pickNlSearchPlaceholderExample(examples = NL_SEARCH_PLACEHOLDER_EXAMPLES) {
  if (!examples.length) return '';
  return examples[Math.floor(Math.random() * examples.length)];
}

/** `code` del 429 de `/parsesearchquery` cuando se agotó el cupo diario NL. */
export const NL_SEARCH_QUOTA_EXCEEDED_CODE = 'NL_SEARCH_QUOTA_EXCEEDED';

/** Fallback si el 429 de cupo llega sin `error` legible. Sin número: el límite lo fija la API. */
export const NL_SEARCH_QUOTA_EXCEEDED_FALLBACK_MESSAGE = 'Usaste tus búsquedas inteligentes de hoy. Se renuevan a las 00:00. Mientras tanto podés usar los filtros.';
